"use strict";
const validators = require('./validators');
const errorMessages = require('./constants');
const { errors: { emptyNodeError }, } = errorMessages;
function validateNodes(nodes) {
    return nodes.reduce((errors, node) => {
        if (node.type === 'placeholder')
            return errors;
        if (node.type === 'empty') {
            return Object.assign(Object.assign({}, errors), { [node.id]: [emptyNodeError] });
        }
        if (!node) {
            throw new Error('Empty node passed for validation');
        }
        const validator = validators[node.type];
        if (!validator) {
            const error = new Error(`Encountered a node that doesn't have a validator. Node type:${node.type}`);
            error.data = node;
            throw error;
        }
        const err = validator(node);
        if (err) {
            return Object.assign(Object.assign({}, errors), { [node.id]: err });
        }
        return errors;
    }, {});
}
module.exports = {
    validateNodes,
};
//# sourceMappingURL=validateWorkflow.js.map